import { AnalyticsEvent } from '../models';

export class CreateAccountPageLoadEvent implements AnalyticsEvent {
  name = 'CreateAccountPageLoadEvent';
}